var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellingHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 5.82661C10.0051 8.61172 7.75846 10.8891 5.00362 10.8911C3.81381 10.8919 2.72091 10.4726 1.86206 9.77185C1.63873 9.58963 1.62203 9.25125 1.82498 9.04608L2.05214 8.81643C2.2257 8.64095 2.5028 8.62175 2.6951 8.77599C3.32786 9.28362 4.12865 9.58661 5 9.58661C7.0505 9.58661 8.70967 7.90888 8.70967 5.83617C8.70967 3.76314 7.05018 2.08573 5 2.08573C4.01584 2.08573 3.12199 2.47238 2.4583 3.10349L3.48157 4.138C3.6848 4.34346 3.54086 4.69474 3.25349 4.69474H0.32258C0.144415 4.69474 0 4.54873 0 4.36861V1.4055C0 1.11496 0.347459 0.969448 0.550685 1.17489L1.54609 2.18123C2.44373 1.31396 3.66032 0.781233 5 0.781233C7.75826 0.781233 9.99489 3.03924 9.99999 5.82661ZM5.64516 7.75123V7.32584C5.64516 7.32584 5.64516 7.32584 5.64516 7.01419V5.84329V3.71636C5.24043 3.41154 5.42852 3.22717 5.16129 3.22717L4.93217 3.27442C4.66493 3.27442 4.35484 3.44619 4.35484 3.71636V6.48131V7.75123C4.56578 7.91709 5.48108 7.9645 5.64516 7.75123Z",
    fill: "url(#paint0_linear_773_10074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_10074",
    x1: 5,
    y1: 0.606671,
    x2: 5,
    y2: 10.7165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A52626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellingHistory);
export default __webpack_public_path__ + "static/media/selling_history.e99822e78063bf8b9c07f18f49371ee5.svg";
export { ForwardRef as ReactComponent };